module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_null.5019c4e7.png";